import { render, staticRenderFns } from "./ModulHinzufuegenModal.vue?vue&type=template&id=a41a16e8"
import script from "./ModulHinzufuegenModal.vue?vue&type=script&lang=js"
export * from "./ModulHinzufuegenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports